export const USER_QUERY_KEY = 'user';

const userQueryKey = {
  userInfo: () => [USER_QUERY_KEY],
  exportQuota: () => [USER_QUERY_KEY, 'export-quota'],
  NTStatus: () => [USER_QUERY_KEY, 'nt-status'],
};

export default userQueryKey;
